import React from 'react';

export default ({ title, value, textColor = 'text-white', center = false, mx = false }) => {
  return (
    <div className={`sm:mx-2 ${mx ? 'mx-2' : ''} sm:mr-6 ${center ? '' : 'text-start'}`}>
      <div className="sm:text-[20px] text-[12px] sm:leading-6 text-[#ffffff50] font-extrabold">
        {title}
      </div>
      <div className={`sm:text-[26px] text-[14px] sm:leading-6 ${textColor} font-extrabold`}>
        {value}
      </div>
    </div>
  );
};
